var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlide1Bg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 303.12 313.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d4ecff;}.cls-2{fill:#173d7a;}.cls-3{fill:#396caa;}.cls-4{fill:#95d359;}.cls-5{fill:#c13d1a;}.cls-6{fill:#db5126;}.cls-7{fill:#ef602e;}.cls-8{fill:#5793ce;}.cls-9{fill:#274f89;}.cls-10{fill:#fff;}.cls-11{fill:#41b729;}.cls-12{fill:#29ce3d;}.cls-13{fill:#ffc2b0;}.cls-14{fill:#ea9c92;}.cls-15{fill:#18772a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "slide1-bg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "191.89 139.28 177.28 130.85 191.89 122.42 206.49 130.85 206.49 130.85 221.1 139.28 206.49 147.72 206.49 147.72 191.89 156.15 177.28 147.72 191.89 139.28 191.89 139.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "191.89 118.28 191.89 56.44 177.28 48 177.28 109.85 191.89 118.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "191.89 56.44 206.49 48 206.49 109.85 191.89 118.28 191.89 56.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "177.28 48 191.89 39.57 206.49 48 191.89 56.44 177.28 48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "177.28 121.09 191.89 112.66 191.89 118.28 177.28 126.71 177.28 121.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "206.49 126.71 206.49 81.74 191.89 73.3 191.89 118.28 206.49 126.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "206.49 81.74 221.1 73.3 221.1 118.28 206.49 126.71 206.49 81.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "191.89 73.3 206.49 64.87 221.1 73.3 206.49 81.74 191.89 73.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "206.49 126.71 206.49 81.74 191.89 73.3 191.89 118.28 206.49 126.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "206.49 81.74 221.1 73.3 221.1 118.28 206.49 126.71 206.49 81.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "191.89 73.3 206.49 64.87 221.1 73.3 206.49 81.74 191.89 73.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "191.89 135.15 191.89 109.85 177.28 101.41 177.28 126.71 191.89 135.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "191.89 109.85 206.49 101.41 206.49 126.71 191.89 135.15 191.89 109.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "177.28 101.41 191.89 92.98 206.49 101.41 191.89 109.85 177.28 101.41"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2.05,
    y: 165.24,
    width: 1.75,
    height: 5.08,
    transform: "translate(166.18 206.6) rotate(104.37)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 4.56,
    y: 167.69,
    width: 1.75,
    height: 5.08,
    transform: "translate(171.69 207.23) rotate(104.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 7.07,
    y: 170.14,
    width: 1.75,
    height: 5.08,
    transform: "translate(177.2 207.86) rotate(104.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 9.59,
    y: 172.59,
    width: 1.75,
    height: 5.08,
    transform: "translate(182.71 208.48) rotate(104.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.53,292.59,240.84,228.9c3.13-1.8,2.73-5-.87-7l-75.11-43.35c-3.61-2.08-9.06-2.31-12.18-.51L42.37,241.7c-3.12,1.8-2.73,5,.88,7l75.11,43.35C122,294.16,127.41,294.39,130.53,292.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.29,116.42,150.42,51.74a4.27,4.27,0,0,1,3.84-.52h0l.18.08.05,0L158.14,53l-4,2c0,.08,0,.15,0,.22l0,92.1c0,4.61-2.86,10-6.37,12l-109.14,63L38,227.44l-4-1.91c-1.31-.77-2.14-2.51-2.14-5l0-92.1C31.92,123.83,34.77,118.45,38.29,116.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.29,116.42,150.42,51.74a4.27,4.27,0,0,1,3.84-.52h0l.18.08.05,0L158.14,53l-4,2c0,.08,0,.15,0,.22l0,60.7-51,40.32L33.84,121.37A12.64,12.64,0,0,1,38.29,116.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.42,117.87l11,4.62-8.3,6.39-6.93-2.95A16.09,16.09,0,0,1,36.42,117.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.94,227l112.13-64.69c3.52-2,6.37-7.41,6.37-12l0-92.09c0-4.61-2.85-6.7-6.37-4.68L42,118.16c-3.51,2-6.37,7.41-6.37,12l0,92.1C35.58,226.88,38.43,229,41.94,227Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M45.67,220.1,150.4,159.71c3.22-1.85,5.83-6.78,5.83-11l0-84.28c0-4.22-2.61-6.13-5.83-4.28L45.71,120.55c-3.22,1.85-5.83,6.78-5.83,11l0,84.28C39.85,220,42.45,222,45.67,220.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M45.67,220.1,150.4,159.71c3.22-1.85,5.83-6.78,5.83-11l0-84.28c0-4.22-2.61-6.13-5.83-4.28L45.71,120.55c-3.22,1.85-5.83,6.78-5.83,11l0,84.28C39.85,220,42.45,222,45.67,220.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.27,229.81l15.08-2,97.33-56.2c3.12-1.8,8.57-1.58,12.18.5l69,39.81,9.12-1.2v5.17h0a3.55,3.55,0,0,1-2.1,3.2L130.53,282.78c-3.12,1.81-8.57,1.58-12.17-.5L43.25,238.93c-2-1.17-3-2.68-3-4.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.4,194.3l6.92-4h76l37.48,21.62,9.12-1.2v5.17h0a3.55,3.55,0,0,1-2.1,3.2L130.53,282.78a11.26,11.26,0,0,1-6.28,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M238.9,211.26l4-.53v5.17h0a3.55,3.55,0,0,1-2.1,3.2l-1.94,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M129.42,283.3a14.13,14.13,0,0,1-10.34-.64V271.12h10.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.53,277.62l110.31-63.69c3.13-1.8,2.73-5-.87-7l-75.11-43.35c-3.61-2.08-9.06-2.31-12.18-.51L42.37,226.73c-3.12,1.8-2.73,5,.88,7l75.11,43.35C122,279.19,127.41,279.42,130.53,277.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M43.25,231.87l75.11,43.35c3.6,2.08,9,2.31,12.17.51L240.84,212a4.05,4.05,0,0,0,1.94-2.12c.49,1.47-.13,3-1.94,4L130.53,277.62c-3.12,1.8-8.57,1.57-12.17-.51L43.25,233.76c-2.43-1.4-3.39-3.28-2.82-4.91A5.89,5.89,0,0,0,43.25,231.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M193.93,192.85l5-2.89c.4-.23.35-.63-.11-.9l-5.89-3.4a1.75,1.75,0,0,0-1.57-.07l-5,2.89c-.4.23-.35.63.11.9l5.89,3.4A1.75,1.75,0,0,0,193.93,192.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M186.22,197.3l5-2.89c.4-.23.35-.63-.11-.9l-5.89-3.4a1.75,1.75,0,0,0-1.57-.07l-5,2.89c-.4.23-.35.63.12.9l5.89,3.4A1.73,1.73,0,0,0,186.22,197.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.51,201.75l5-2.89c.4-.23.35-.63-.11-.9l-5.89-3.4a1.73,1.73,0,0,0-1.56-.07l-5,2.89c-.41.23-.35.63.11.9l5.89,3.4A1.73,1.73,0,0,0,178.51,201.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.85,198.07l5-2.88c.4-.23.35-.64-.11-.9l-4.94-2.86a1.72,1.72,0,0,0-1.57-.06l-5,2.88c-.4.23-.35.63.11.9l4.95,2.86A1.76,1.76,0,0,0,167.85,198.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.14,202.52l5-2.88c.4-.23.35-.64-.12-.9l-4.94-2.86a1.71,1.71,0,0,0-1.57-.06l-5,2.88c-.4.23-.35.63.12.9l4.94,2.86A1.76,1.76,0,0,0,160.14,202.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.44,207l5-2.88c.4-.23.35-.64-.11-.9l-4.95-2.86a1.69,1.69,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.63.11.9l4.94,2.86A1.78,1.78,0,0,0,152.44,207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.73,211.42l5-2.88c.4-.23.35-.64-.11-.9l-5-2.86a1.69,1.69,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.63.11.9l4.95,2.86A1.76,1.76,0,0,0,144.73,211.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137,215.87l5-2.88c.4-.23.35-.64-.11-.9l-5-2.86a1.69,1.69,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.63.11.9l5,2.86A1.76,1.76,0,0,0,137,215.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.31,220.32l5-2.88c.41-.23.36-.64-.11-.9l-4.94-2.86a1.75,1.75,0,0,0-1.57-.06l-5,2.88c-.4.23-.35.63.11.9l5,2.86A1.76,1.76,0,0,0,129.31,220.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.61,224.77l5-2.88c.4-.23.35-.64-.12-.9l-4.94-2.86a1.72,1.72,0,0,0-1.56-.06L115,221c-.4.23-.35.63.12.9l4.94,2.86A1.78,1.78,0,0,0,121.61,224.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.9,229.22l5-2.88c.4-.23.35-.64-.11-.9l-5-2.86a1.72,1.72,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.63.11.9l4.94,2.86A1.78,1.78,0,0,0,113.9,229.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.19,233.67l5-2.88c.4-.23.35-.64-.11-.9L106.12,227a1.72,1.72,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.63.11.9l4.95,2.86A1.76,1.76,0,0,0,106.19,233.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.48,238.12l5-2.88c.4-.23.35-.64-.11-.9l-4.94-2.86a1.75,1.75,0,0,0-1.57-.06l-5,2.88c-.4.23-.35.63.11.9l5,2.86A1.76,1.76,0,0,0,98.48,238.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156.5,196l5-2.88c.4-.23.35-.63-.12-.9l-4.94-2.86a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.64.12.9l4.94,2.86A1.74,1.74,0,0,0,156.5,196Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.32,191.45l5-2.88c.4-.24.35-.64-.11-.91l-4.95-2.85a1.73,1.73,0,0,0-1.56-.07l-5,2.88c-.4.24-.35.64.11.91l4.94,2.85A1.75,1.75,0,0,0,164.32,191.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M172.15,186.92l10.75-6.2c.4-.23.35-.64-.11-.91L177.85,177a1.75,1.75,0,0,0-1.57-.07l-10.75,6.21c-.4.23-.35.64.12.9l4.94,2.86A1.72,1.72,0,0,0,172.15,186.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.68,181.42l8.72-5c.4-.23.35-.63-.11-.9l-4.95-2.85a1.73,1.73,0,0,0-1.56-.07l-8.72,5c-.41.23-.35.63.11.9l4.94,2.86A1.78,1.78,0,0,0,166.68,181.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M148.79,200.41l5-2.88c.4-.23.35-.63-.11-.9l-4.95-2.86a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.64.11.9l4.94,2.86A1.75,1.75,0,0,0,148.79,200.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.08,204.86l5-2.88c.4-.23.35-.63-.11-.9l-5-2.86a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.64.11.9l5,2.86A1.69,1.69,0,0,0,141.08,204.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.37,209.31l5-2.88c.4-.23.35-.63-.11-.9l-4.94-2.86a1.78,1.78,0,0,0-1.57-.06l-5,2.88c-.4.23-.35.64.11.9l5,2.86A1.69,1.69,0,0,0,133.37,209.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.66,213.76l5-2.88c.4-.23.35-.63-.12-.9l-4.94-2.86a1.78,1.78,0,0,0-1.57-.06l-5,2.88c-.4.23-.35.64.12.9l4.94,2.86A1.69,1.69,0,0,0,125.66,213.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118,218.21l5-2.88c.4-.23.35-.63-.11-.9l-5-2.86a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.41.23-.35.64.11.9l4.94,2.86A1.72,1.72,0,0,0,118,218.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.25,222.66l5-2.88c.4-.23.35-.63-.11-.9L110.18,216a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.64.11.9l5,2.86A1.69,1.69,0,0,0,110.25,222.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.54,227.11l5-2.88c.4-.23.35-.63-.11-.9l-5-2.86a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.64.11.9l5,2.86A1.69,1.69,0,0,0,102.54,227.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.83,231.56l5-2.88c.41-.23.35-.63-.11-.9l-4.94-2.86a1.78,1.78,0,0,0-1.57-.06l-5,2.88c-.4.23-.35.64.11.9l5,2.86A1.69,1.69,0,0,0,94.83,231.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.13,236l5-2.88c.4-.23.35-.63-.12-.9l-4.94-2.86a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.64.12.9L85.56,236A1.71,1.71,0,0,0,87.13,236Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.42,243.93l10.89-6.29c.4-.23.35-.64-.11-.9l-4.94-2.86a1.72,1.72,0,0,0-1.57-.06L66.8,240.1c-.4.23-.35.64.11.91l5,2.85A1.73,1.73,0,0,0,73.42,243.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.42,235.26,67.61,230c.4-.23.35-.63-.11-.9l-5-2.85a1.73,1.73,0,0,0-1.56-.07l-9.19,5.31c-.4.23-.35.63.11.9l4.94,2.86A1.78,1.78,0,0,0,58.42,235.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.29,199.54l5-2.88c.4-.23.35-.63-.11-.9l-4.95-2.86a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.64.11.9l4.95,2.86A1.72,1.72,0,0,0,135.29,199.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.19,195l5-2.88c.4-.23.35-.64-.11-.9l-4.95-2.86a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.63.11.9l4.95,2.86A1.76,1.76,0,0,0,143.19,195Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.09,190.42l5-2.88c.4-.23.35-.64-.11-.9L151,183.78a1.72,1.72,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.63.11.9l4.95,2.86A1.76,1.76,0,0,0,151.09,190.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159,185.86l5-2.88c.4-.23.35-.64-.11-.9l-5-2.86a1.69,1.69,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.63.11.9l4.94,2.86A1.78,1.78,0,0,0,159,185.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.58,204l5-2.88c.4-.23.35-.63-.11-.9l-4.94-2.86a1.78,1.78,0,0,0-1.57-.06l-5,2.88c-.4.23-.35.64.11.9l5,2.86A1.72,1.72,0,0,0,127.58,204Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.87,208.44l5-2.88c.4-.23.35-.63-.12-.9l-4.94-2.86a1.78,1.78,0,0,0-1.57-.06l-5,2.88c-.4.23-.35.64.12.9l4.94,2.86A1.72,1.72,0,0,0,119.87,208.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.17,212.89l5-2.88c.4-.23.35-.63-.11-.9l-5-2.86a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.41.23-.36.64.11.9l4.94,2.86A1.75,1.75,0,0,0,112.17,212.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.46,217.34l5-2.88c.4-.23.35-.63-.11-.9l-5-2.86a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.64.11.9l5,2.86A1.72,1.72,0,0,0,104.46,217.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.75,221.79l5-2.88c.4-.23.35-.63-.11-.9l-4.95-2.86a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.64.11.9l5,2.86A1.72,1.72,0,0,0,96.75,221.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89,226.24l5-2.88c.41-.23.35-.63-.11-.9L89,219.6a1.78,1.78,0,0,0-1.57-.06l-5,2.88c-.4.23-.35.64.11.9l5,2.86A1.72,1.72,0,0,0,89,226.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.34,230.69l5-2.88c.4-.23.35-.63-.12-.9l-4.94-2.86a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.64.12.9l4.94,2.86A1.74,1.74,0,0,0,81.34,230.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.63,235.14l5-2.88c.4-.23.35-.63-.11-.9l-5-2.86a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.64.11.9l4.94,2.86A1.75,1.75,0,0,0,73.63,235.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.92,239.59l5-2.88c.4-.23.35-.63-.11-.9l-5-2.86a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.64.11.9l5,2.86A1.72,1.72,0,0,0,65.92,239.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.35,188.54l5-2.89c.4-.23.35-.63-.11-.9l-4.95-2.85a1.73,1.73,0,0,0-1.56-.07l-5,2.88c-.4.23-.35.64.11.91l4.94,2.85A1.75,1.75,0,0,0,139.35,188.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147,184.11l5-2.88c.4-.24.35-.64-.11-.91l-5-2.85a1.73,1.73,0,0,0-1.56-.07l-5,2.89c-.4.23-.35.63.11.9l4.94,2.85A1.75,1.75,0,0,0,147,184.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.69,179.68l5-2.88c.4-.23.35-.64-.11-.9L154.62,173a1.69,1.69,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.63.11.9l4.94,2.86A1.78,1.78,0,0,0,154.69,179.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.36,175.25l5-2.88c.4-.23.35-.64-.11-.9l-5-2.86a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.41.23-.35.63.11.9l4.94,2.86A1.78,1.78,0,0,0,162.36,175.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.47,170.7l5-2.88c.4-.23.35-.64-.11-.91l-1.64-.94a1.69,1.69,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.63.11.9l1.64.94A1.73,1.73,0,0,0,154.47,170.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.46,176.48l5-2.88c.4-.24.35-.64-.11-.91l-1.63-.94a1.75,1.75,0,0,0-1.57-.07l-5,2.89c-.4.23-.35.63.11.9l1.64.94A1.73,1.73,0,0,0,144.46,176.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.82,180.89l5-2.88c.4-.24.35-.64-.12-.91l-1.63-.94a1.75,1.75,0,0,0-1.57-.07l-5,2.89c-.4.23-.35.63.12.9l1.63.94A1.73,1.73,0,0,0,136.82,180.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.19,185.3l5-2.89c.4-.23.35-.63-.11-.9l-1.64-.94a1.73,1.73,0,0,0-1.56-.07l-5,2.88c-.4.24-.35.64.11.91l1.63.94A1.75,1.75,0,0,0,129.19,185.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.55,189.71l5-2.89c.4-.23.35-.63-.11-.9l-1.64-.94a1.73,1.73,0,0,0-1.56-.07l-5,2.88c-.4.24-.35.64.11.91l1.64.94A1.73,1.73,0,0,0,121.55,189.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.91,214.32l5-2.88c.4-.23.35-.63-.11-.9l-1.64-.94a1.73,1.73,0,0,0-1.56-.07l-5,2.88c-.4.23-.35.64.11.9l1.64.95A1.72,1.72,0,0,0,78.91,214.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.27,218.73l5-2.88c.4-.23.35-.63-.11-.9L74.52,214a1.78,1.78,0,0,0-1.57-.06l-5,2.88c-.4.23-.35.64.11.9l1.64.95A1.72,1.72,0,0,0,71.27,218.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.64,223.14l5-2.88c.4-.23.35-.63-.12-.9l-1.63-1a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.64.12.9l1.63,1A1.78,1.78,0,0,0,63.64,223.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56,227.55l5-2.88c.4-.23.35-.64-.11-.9l-1.64-1a1.76,1.76,0,0,0-1.56-.06l-5,2.88c-.4.23-.35.64.11.9l1.63,1A1.78,1.78,0,0,0,56,227.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.64,193l5-2.89c.4-.23.35-.63-.11-.9l-5-2.85a1.73,1.73,0,0,0-1.56-.07l-5,2.88c-.4.23-.35.64.11.91l5,2.85A1.73,1.73,0,0,0,131.64,193Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.93,197.44l5-2.89c.4-.23.35-.63-.11-.9l-4.94-2.85a1.75,1.75,0,0,0-1.57-.07l-5,2.88c-.4.23-.35.64.11.91l5,2.85A1.73,1.73,0,0,0,123.93,197.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.23,201.89l5-2.89c.4-.23.35-.63-.12-.9l-4.94-2.85a1.73,1.73,0,0,0-1.56-.07l-5,2.88c-.4.23-.35.64.12.91l4.94,2.85A1.75,1.75,0,0,0,116.23,201.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.52,206.34l5-2.89c.4-.23.35-.63-.11-.9l-5-2.85a1.73,1.73,0,0,0-1.56-.07l-5,2.88c-.4.23-.35.64.11.91l4.94,2.85A1.75,1.75,0,0,0,108.52,206.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.81,210.79l5-2.89c.4-.23.35-.63-.11-.9l-5-2.85a1.73,1.73,0,0,0-1.56-.07l-5,2.88c-.4.23-.35.64.11.91l5,2.85A1.73,1.73,0,0,0,100.81,210.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.1,215.24l5-2.89c.4-.23.35-.63-.11-.9L93,208.6a1.75,1.75,0,0,0-1.57-.07l-5,2.88c-.4.24-.35.64.11.91l5,2.85A1.73,1.73,0,0,0,93.1,215.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.39,219.69l5-2.89c.4-.23.35-.63-.12-.9l-4.94-2.85a1.75,1.75,0,0,0-1.57-.07l-5,2.88c-.4.24-.35.64.12.91l4.94,2.85A1.73,1.73,0,0,0,85.39,219.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.69,224.14l5-2.89c.4-.23.35-.63-.11-.9l-4.95-2.85a1.73,1.73,0,0,0-1.56-.07l-5,2.88c-.41.24-.36.64.11.91l4.94,2.85A1.75,1.75,0,0,0,77.69,224.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70,228.59l5-2.89c.4-.23.35-.63-.11-.9l-5-2.85a1.73,1.73,0,0,0-1.56-.07l-5,2.88c-.4.24-.35.64.11.91l5,2.85A1.73,1.73,0,0,0,70,228.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.71,193.54l14.7-8.49c.4-.23.35-.64-.12-.9l-4.94-2.86a1.69,1.69,0,0,0-1.56-.06l-14.7,8.48c-.4.23-.35.64.11.91l4.94,2.85A1.75,1.75,0,0,0,175.71,193.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81,248.21l14.69-8.49c.41-.23.36-.64-.11-.9L90.66,236a1.72,1.72,0,0,0-1.57-.06l-14.7,8.48c-.4.23-.35.64.12.91l4.94,2.85A1.75,1.75,0,0,0,81,248.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.84,240.24l5-2.88c.4-.23.35-.64-.11-.91l-5.89-3.4a1.78,1.78,0,0,0-1.57-.06l-5,2.88c-.4.23-.35.64.12.9l5.89,3.4A1.73,1.73,0,0,0,111.84,240.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.81,207.92l8-4.61c.4-.23.35-.63-.12-.9l-5.89-3.4a1.69,1.69,0,0,0-1.56-.06l-8,4.6c-.4.23-.35.64.11.91l5.89,3.4A1.76,1.76,0,0,0,167.81,207.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.27,236l8-4.61c.4-.23.35-.63-.11-.9l-5.89-3.4a1.75,1.75,0,0,0-1.57-.07l-8,4.61c-.4.23-.35.64.11.91l5.89,3.4A1.78,1.78,0,0,0,119.27,236Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.69,214.34l8-4.61c.4-.23.35-.63-.12-.9l-5.89-3.4a1.69,1.69,0,0,0-1.56-.06l-8,4.6c-.4.24-.35.64.11.91l5.89,3.4A1.72,1.72,0,0,0,156.69,214.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.05,205.4l-34.7,20a.48.48,0,0,0,0,.9l6,3.47a1.72,1.72,0,0,0,1.56,0l34.7-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.3,248.31l-5.56,3.21c-.33.19-.29.52.09.74l2.41,1.39a1.42,1.42,0,0,0,1.28,0l5.56-3.21c.33-.19.29-.52-.09-.74l-2.41-1.39A1.42,1.42,0,0,0,90.3,248.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.07,243.82,92.51,247c-.33.19-.29.52.09.74L95,249.16a1.42,1.42,0,0,0,1.28.05l5.56-3.21c.33-.18.29-.52-.09-.74l-2.41-1.39A1.42,1.42,0,0,0,98.07,243.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.78,239.37l-5.56,3.21c-.33.19-.29.52.09.74l2.41,1.39a1.42,1.42,0,0,0,1.28,0l5.56-3.21c.33-.18.29-.52-.09-.74l-2.41-1.39A1.42,1.42,0,0,0,105.78,239.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.81,241.36l-5.56,3.21c-.32.19-.28.52.1.74l2.41,1.39a1.42,1.42,0,0,0,1.28.06l5.56-3.21c.33-.19.28-.52-.1-.74l-2.41-1.39A1.42,1.42,0,0,0,93.81,241.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.54,131.79,90.31,129a2,2,0,0,0,.82-1.54h0c0-.6-.34-.87-.78-.61l-4.78,2.75a2,2,0,0,0-.82,1.54h0C84.74,131.77,85.1,132,85.54,131.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.17,138.35l7-4.06a2,2,0,0,0,.82-1.54h0c0-.6-.35-.87-.79-.62l-7,4.07a2,2,0,0,0-.82,1.54h0C73.37,138.33,73.72,138.61,74.17,138.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.9,157.24l4.78-2.75A2,2,0,0,0,93.5,153h0c0-.6-.34-.87-.79-.62l-4.77,2.76a2,2,0,0,0-.82,1.54h0C87.11,157.22,87.46,157.5,87.9,157.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.77,163.09l7-4.06a2,2,0,0,0,.82-1.54h0c0-.6-.35-.87-.79-.61l-7,4.06a2,2,0,0,0-.82,1.54h0C77,163.07,77.32,163.35,77.77,163.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.63,128.7l3-1.72a2,2,0,0,0,.82-1.54h0c0-.6-.34-.87-.78-.62l-3,1.72a2,2,0,0,0-.82,1.54h0C97.83,128.68,98.19,129,98.63,128.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.44,139.05l9.12-5.26a2,2,0,0,0,.82-1.54h0c0-.6-.35-.87-.79-.62l-9.11,5.26a2,2,0,0,0-.82,1.54h0C87.65,139,88,139.3,88.44,139.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.43,144.53l3-1.72a2,2,0,0,0,.82-1.54h0c0-.59-.34-.87-.79-.61l-3,1.72a2,2,0,0,0-.82,1.54h0C93.63,144.51,94,144.79,94.43,144.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.25,174.07l8-4.6a2,2,0,0,0,.82-1.54h0c0-.6-.34-.87-.78-.62l-8,4.6a2,2,0,0,0-.82,1.54h0C73.45,174.05,73.81,174.32,74.25,174.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.35,152.94l1.91-1.1a2,2,0,0,0,.82-1.54h0c0-.6-.34-.87-.78-.62l-1.92,1.11a2,2,0,0,0-.82,1.54h0C94.56,152.92,94.91,153.2,95.35,152.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.74,162.23l2.38-1.37a2,2,0,0,0,.82-1.54h0c0-.59-.34-.87-.79-.61l-2.37,1.37a2,2,0,0,0-.82,1.54h0C94,162.22,94.3,162.49,94.74,162.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.49,167.57,91.76,164a2,2,0,0,0,.82-1.54h0c0-.6-.34-.87-.79-.62l-6.26,3.62a2,2,0,0,0-.82,1.54h0C84.7,167.55,85.05,167.83,85.49,167.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.54,168l4.5-2.61a1.93,1.93,0,0,0,.82-1.53h0c0-.6-.34-.87-.78-.62l-4.51,2.6a2,2,0,0,0-.82,1.54h0C91.74,168,92.1,168.23,92.54,168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.41,178l2.89-1.67a1.94,1.94,0,0,0,.82-1.54h0c0-.59-.34-.87-.78-.61l-2.9,1.67a1.94,1.94,0,0,0-.81,1.54h0C66.62,178,67,178.29,67.41,178Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.33,150.94l8-4.6a2,2,0,0,0,.82-1.54h0c0-.59-.34-.87-.79-.61l-8,4.59a2,2,0,0,0-.82,1.54h0C82.54,150.92,82.89,151.19,83.33,150.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.6,146.31l13.88-8a2,2,0,0,0,.82-1.54h0c0-.59-.34-.87-.78-.61l-13.88,8a2,2,0,0,0-.82,1.54h0C82.81,146.3,83.16,146.57,83.6,146.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.37,151.92l8-4.6a2,2,0,0,0,.82-1.53h0c0-.6-.35-.87-.79-.62l-8,4.6a2,2,0,0,0-.82,1.54h0C88.58,151.9,88.93,152.18,89.37,151.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.29,154.43l2.9-1.67a2,2,0,0,0,.82-1.54h0c0-.6-.34-.87-.79-.62l-2.89,1.67a2,2,0,0,0-.82,1.54h0C76.5,154.41,76.85,154.68,77.29,154.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.7,150.75l17.14-9.9a2,2,0,0,0,.82-1.54h0c0-.59-.35-.87-.79-.61l-17.14,9.89a2,2,0,0,0-.82,1.54h0C51.9,150.73,52.26,151,52.7,150.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.62,161.88l9.57-5.53a2,2,0,0,0,.82-1.54h0c0-.59-.34-.87-.78-.61l-9.58,5.52a2,2,0,0,0-.82,1.54h0C86.82,161.86,87.17,162.13,87.62,161.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.64,126.53l7-4.07a1.94,1.94,0,0,0,.82-1.54h0c0-.59-.34-.87-.78-.61l-7,4.06a2,2,0,0,0-.82,1.54h0C93.85,126.51,94.2,126.78,94.64,126.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.8,172.3l8.15-4.71a2,2,0,0,0,.82-1.54h0c0-.6-.34-.87-.78-.61l-8.16,4.7a2,2,0,0,0-.81,1.54h0C92,172.28,92.36,172.55,92.8,172.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.24,179.38l-42-24.45c-8.32-4.8-16.16-5.56-22.09-2.14S228,163.39,228,173v3.08c.3.2.61.4.93.59V173c0-9.26,3.1-16.15,8.72-19.4s13.15-2.48,21.17,2.15l42,24.44a.45.45,0,0,0,.63-.16A.47.47,0,0,0,301.24,179.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.29,150.26V55.63c0-18.94-13.34-42.05-29.75-51.52-8-4.64-15.61-5.38-21.33-2.07s-8.88,10.23-8.88,19.51v6.6l.92.92V21.55c0-8.93,3-15.58,8.42-18.71s12.67-2.4,20.41,2.07c16.15,9.32,29.29,32.07,29.29,50.72v94.63c0,15.7,9.23,34.28,21.76,45.46v-1.24C179.1,183.42,170.29,165.47,170.29,150.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.33,31h0a37.18,37.18,0,0,0-19-9.28C79.66,20,74.81,33.67,74.81,33.67A75.8,75.8,0,0,0,73.51,45c0,4.21.35,19.51.35,19.51L111,43.12h0a.46.46,0,0,0,.25-.41V31.84C111,31.53,110.64,31.35,110.33,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.47,44.49,74.11,53s11.94,9.66,16.44,23.46,4.94,11.4,5,25.13.15,83.35.15,83.35-1,12.23,2,21.69,8.52,19.95,15,26.82,16.08,15,24.94,14.19,14.81-4.07,16.52-18.08v-13l-.37-.38c6.09,5.63,13.71,10.79,20.86,10.14,8.86-.79,14.82-4.06,16.52-18.08v-13s-10.69-10.89-14.85-19.87-6.32-17.28-6.39-24.69-.15-71.1-.15-71.1.46-26.41-.65-30.58S165.45,22.68,143.66,6.7c-11-8-19.17-7.66-24.59-4.16l.14-.5L84,22.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.29,246.49c.48-.65,6.75-4.86,8.35-12.27a57.7,57.7,0,0,0,.8-10.38s0-3.49-.11-6.65l-.21-.18v-1.25c.06.06.12.1.17.16,0-.72,0-1.39-.08-2-.18-3.29,2.25-10.31,2.25-10.31s3.45-9.41,13.73-9.77c9.12-.32,18.73,6.24,20.77,7.72v-4.25l.42.27c0-.57,0-1.15,0-1.72l-.21-.18v-1.24l.17.15c0-.71-.05-1.38-.08-1.95-.18-3.3,2.25-10.32,2.25-10.32s3.45-9.4,13.73-9.77c9.12-.32,18.73,6.25,20.77,7.72v-4.24c.3.2.61.4.93.59v7.43c0,9-3,15.78-8.45,19.15l0,0-.19.11-.15.1-.1.05L182.3,225.21l0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.15,174.08a8.53,8.53,0,0,1,.78-.35l.45-.23,35.78-20.71a19.2,19.2,0,0,1,14.52-.54c7.95,2.91,49.61,27.9,49.61,27.9l-37.21,21.44h0l-.1,0-36.91,21.27s-20.88-12.94-35.32-21.29l-.93-.53c-5.9-3.39-10.59-5.93-12.06-6.32-8.91-2.36-15.11.52-16.72,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162,196.14l-.43.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.32,52.33h0a37.1,37.1,0,0,0-19-9.28C42.64,41.26,37.8,55,37.8,55a75.61,75.61,0,0,0-1.3,11.33c0,4.21.35,19.51.35,19.51L74,64.4h0a.46.46,0,0,0,.25-.41V53.13C73.93,52.82,73.63,52.64,73.32,52.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138.05,248.18c-4.1,0-8.63-1.37-13.32-4.08C108.45,234.7,95.2,211.75,95.2,193V98.32c0-18.64-13.14-41.4-29.29-50.72-7.74-4.47-15-5.2-20.41-2.07s-8.41,9.77-8.41,18.71V85.39a.47.47,0,0,1-.93,0V64.24C36.16,55,39.31,48,45,44.73s13.3-2.57,21.33,2.06c16.41,9.47,29.75,32.59,29.75,51.53V193c0,18.51,13,41.1,29.07,50.35,7.68,4.43,14.88,5.16,20.26,2s8.35-9.7,8.35-18.57v-11.1c0-9.6,3.27-16.78,9.19-20.2s13.77-2.66,22.09,2.14l42,24.45a.47.47,0,0,1,.17.64.46.46,0,0,1-.63.16l-42-24.44c-8-4.63-15.54-5.4-21.17-2.15s-8.72,10.14-8.72,19.4v11.1c0,9.21-3.13,16.09-8.82,19.38A15.52,15.52,0,0,1,138.05,248.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.15,121.51l6.21-3.58a2.56,2.56,0,0,0,1.06-2h0c0-.78-.44-1.13-1-.8l-6.2,3.58a2.56,2.56,0,0,0-1.07,2h0C134.12,121.49,134.58,121.85,135.15,121.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M122,129.12l9.15-5.28a2.54,2.54,0,0,0,1.07-2h0c0-.78-.44-1.13-1-.8L122,126.32a2.56,2.56,0,0,0-1.07,2h0C120.94,129.1,121.4,129.46,122,129.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.85,97.86,147.7,91a2.56,2.56,0,0,0,1.07-2h0c0-.77-.45-1.13-1-.8L135.9,95.06a2.56,2.56,0,0,0-1.07,2h0C134.82,97.83,135.28,98.19,135.85,97.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M143.63,105l3.88-2.24a2.54,2.54,0,0,0,1.07-2h0c0-.77-.45-1.13-1-.8l-3.88,2.24a2.57,2.57,0,0,0-1.07,2h0C142.6,105,143.06,105.32,143.63,105Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M144.83,115.92l2.49-1.43a2.56,2.56,0,0,0,1.07-2h0c0-.77-.45-1.13-1-.79l-2.49,1.43a2.59,2.59,0,0,0-1.07,2h0C143.8,115.9,144.26,116.26,144.83,115.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M129.21,113.32l10.36-6a2.56,2.56,0,0,0,1.06-2h0c0-.78-.44-1.13-1-.8l-10.35,6a2.54,2.54,0,0,0-1.07,2h0C128.18,113.29,128.63,113.65,129.21,113.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M129.56,107.31l18.05-10.43a2.56,2.56,0,0,0,1.06-2h0c0-.77-.44-1.13-1-.8L129.6,104.5a2.58,2.58,0,0,0-1.06,2h0C128.52,107.28,129,107.64,129.56,107.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M137.06,114.6l10.36-6a2.56,2.56,0,0,0,1.06-2h0c0-.78-.44-1.13-1-.8l-10.35,6a2.54,2.54,0,0,0-1.07,2h0C136,114.57,136.48,114.93,137.06,114.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M121.35,117.85l3.77-2.17a2.56,2.56,0,0,0,1.06-2h0c0-.77-.44-1.13-1-.8l-3.76,2.17a2.59,2.59,0,0,0-1.07,2h0C120.32,117.83,120.78,118.19,121.35,117.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M132.08,88.41l6.2-3.58a2.54,2.54,0,0,0,1.07-2h0c0-.78-.45-1.14-1-.8l-6.21,3.58a2.56,2.56,0,0,0-1.06,2h0C131,88.39,131.5,88.74,132.08,88.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M117.29,97l9.15-5.29a2.53,2.53,0,0,0,1.07-2h0c0-.77-.45-1.13-1-.8l-9.15,5.29a2.54,2.54,0,0,0-1.07,2h0C116.26,96.92,116.71,97.28,117.29,97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.15,121.51l6.21-3.58a2.56,2.56,0,0,0,1.06-2h0c0-.78-.44-1.13-1-.8l-6.2,3.58a2.56,2.56,0,0,0-1.07,2h0C134.12,121.49,134.58,121.85,135.15,121.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M122,129.12l9.15-5.28a2.54,2.54,0,0,0,1.07-2h0c0-.78-.44-1.13-1-.8L122,126.32a2.56,2.56,0,0,0-1.07,2h0C120.94,129.1,121.4,129.46,122,129.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M149.1,84.4,153,82.16a2.54,2.54,0,0,0,1.07-2h0c0-.78-.44-1.13-1-.8l-3.88,2.24a2.56,2.56,0,0,0-1.06,2h0C148.06,84.37,148.52,84.73,149.1,84.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.85,97.86,147.7,91a2.56,2.56,0,0,0,1.07-2h0c0-.77-.45-1.13-1-.8L135.9,95.06a2.56,2.56,0,0,0-1.07,2h0C134.82,97.83,135.28,98.19,135.85,97.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M143.63,105l3.88-2.24a2.54,2.54,0,0,0,1.07-2h0c0-.77-.45-1.13-1-.8l-3.88,2.24a2.57,2.57,0,0,0-1.07,2h0C142.6,105,143.06,105.32,143.63,105Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M117.39,143.39l10.36-6a2.57,2.57,0,0,0,1.07-2h0c0-.77-.45-1.13-1-.8l-10.36,6a2.57,2.57,0,0,0-1.07,2h0C116.36,143.37,116.82,143.72,117.39,143.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M144.83,115.92l2.49-1.43a2.56,2.56,0,0,0,1.07-2h0c0-.77-.45-1.13-1-.79l-2.49,1.43a2.59,2.59,0,0,0-1.07,2h0C143.8,115.9,144.26,116.26,144.83,115.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M144,128l3.09-1.79a2.54,2.54,0,0,0,1.07-2h0c0-.77-.45-1.13-1-.8l-3.09,1.79a2.54,2.54,0,0,0-1.07,2h0C143,128,143.47,128.34,144,128Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M132,135l8.15-4.71a2.55,2.55,0,0,0,1.06-2h0c0-.77-.44-1.13-1-.8l-8.15,4.71a2.56,2.56,0,0,0-1.06,2h0C131,134.93,131.44,135.28,132,135Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M141.18,135.47l5.86-3.38a2.56,2.56,0,0,0,1.06-2h0c0-.78-.44-1.13-1-.8l-5.86,3.38a2.58,2.58,0,0,0-1.06,2h0C140.14,135.45,140.6,135.81,141.18,135.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M129.21,113.32l10.36-6a2.56,2.56,0,0,0,1.06-2h0c0-.78-.44-1.13-1-.8l-10.35,6a2.54,2.54,0,0,0-1.07,2h0C128.18,113.29,128.63,113.65,129.21,113.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M129.56,107.31l18.05-10.43a2.56,2.56,0,0,0,1.06-2h0c0-.77-.44-1.13-1-.8L129.6,104.5a2.58,2.58,0,0,0-1.06,2h0C128.52,107.28,129,107.64,129.56,107.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M137.06,114.6l10.36-6a2.56,2.56,0,0,0,1.06-2h0c0-.78-.44-1.13-1-.8l-10.35,6a2.54,2.54,0,0,0-1.07,2h0C136,114.57,136.48,114.93,137.06,114.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M121.35,117.85l3.77-2.17a2.56,2.56,0,0,0,1.06-2h0c0-.77-.44-1.13-1-.8l-3.76,2.17a2.59,2.59,0,0,0-1.07,2h0C120.32,117.83,120.78,118.19,121.35,117.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M134.78,127.54l12.45-7.19a2.55,2.55,0,0,0,1.06-2h0c0-.77-.44-1.13-1-.8l-12.45,7.19a2.56,2.56,0,0,0-1.06,2h0C133.74,127.52,134.2,127.88,134.78,127.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M143.92,81.58l9.15-5.29a2.57,2.57,0,0,0,1.07-2h0c0-.77-.45-1.13-1-.8L144,78.78a2.55,2.55,0,0,0-1.06,2h0C142.88,81.55,143.34,81.91,143.92,81.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M141.52,141.09l10.6-6.12a2.56,2.56,0,0,0,1.06-2h0c0-.78-.44-1.13-1-.8l-10.6,6.12a2.56,2.56,0,0,0-1.06,2h0C140.49,141.07,140.94,141.42,141.52,141.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M136.61,177.2l6.21-3.59a2.55,2.55,0,0,0,1.06-2h0c0-.77-.44-1.13-1-.8l-6.2,3.59a2.54,2.54,0,0,0-1.07,2h0C135.58,177.17,136,177.53,136.61,177.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M123.43,184.81l9.15-5.29a2.54,2.54,0,0,0,1.07-2h0c0-.77-.45-1.13-1-.8L123.48,182a2.54,2.54,0,0,0-1.07,2h0C122.4,184.78,122.85,185.14,123.43,184.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M137.31,153.54l11.85-6.84a2.57,2.57,0,0,0,1.07-2h0c0-.78-.45-1.13-1-.8l-11.85,6.84a2.57,2.57,0,0,0-1.07,2h0C136.28,153.52,136.74,153.87,137.31,153.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M145.09,160.67l3.88-2.23a2.59,2.59,0,0,0,1.07-2h0c0-.77-.45-1.13-1-.79l-3.88,2.23a2.59,2.59,0,0,0-1.07,2h0C144.06,160.65,144.52,161,145.09,160.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M146.29,171.61l2.49-1.44a2.57,2.57,0,0,0,1.07-2h0c0-.77-.45-1.13-1-.8l-2.49,1.44a2.54,2.54,0,0,0-1.07,2h0C145.26,171.58,145.72,171.94,146.29,171.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M130.67,169,141,163a2.56,2.56,0,0,0,1.06-2h0c0-.77-.44-1.13-1-.8l-10.36,6a2.56,2.56,0,0,0-1.06,2h0C129.64,169,130.09,169.34,130.67,169Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M131,163l18-10.42a2.56,2.56,0,0,0,1.06-2h0c0-.78-.44-1.14-1-.8l-18.05,10.42a2.56,2.56,0,0,0-1.06,2h0C130,163,130.44,163.32,131,163Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M138.52,170.28l10.36-6a2.56,2.56,0,0,0,1.06-2h0c0-.77-.44-1.13-1-.8l-10.36,6a2.58,2.58,0,0,0-1.06,2h0C137.49,170.26,137.94,170.62,138.52,170.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M122.81,173.54l3.77-2.17a2.58,2.58,0,0,0,1.06-2h0c0-.77-.44-1.13-1-.8l-3.76,2.18a2.57,2.57,0,0,0-1.07,2h0C121.78,173.51,122.24,173.87,122.81,173.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "91.23 306.81 79.73 300.17 68.24 306.81 79.73 313.45 91.23 306.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "66.83 292.53 55.33 285.9 43.84 292.53 55.33 299.17 66.83 292.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "42.5 278.6 31 271.96 19.5 278.6 31 285.23 42.5 278.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "55.33 292.53 55.33 257.13 66.83 250.5 66.83 285.9 55.33 292.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "55.33 257.13 43.84 250.5 43.84 285.9 55.33 292.53 55.33 257.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "55.33 292.53 55.33 257.13 66.83 250.5 66.83 285.9 55.33 292.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "79.73 306.81 79.73 286.9 91.23 280.26 91.23 300.17 79.73 306.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "79.73 286.9 68.24 280.26 68.24 300.17 79.73 306.81 79.73 286.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "91.23 280.26 79.73 273.62 68.24 280.26 79.73 286.9 91.23 280.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "31 278.6 31 229.92 42.5 223.28 42.5 271.96 31 278.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "31 229.92 19.5 223.28 19.5 271.96 31 278.6 31 229.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "42.5 223.28 31 216.65 19.5 223.28 31 229.92 42.5 223.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "66.83 250.5 55.33 243.86 43.84 250.5 55.33 257.13 66.83 250.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M254.79,240.4s3.55-1.79,5.73.87,5.3,9,5.39,13.21-3.36,4-5.42,3-8.06-9.72-8.43-11.43.43-4,1-4.47S254.79,240.4,254.79,240.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254,239.54l-.17,3.68a2.09,2.09,0,0,0,1,1.91,4.08,4.08,0,0,0,2.74.43c2.67-.43,2.91-1.19,3.1-4.87S254,239.54,254,239.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M267.78,233.33s3.55-1.79,5.73.88,5.3,8.95,5.39,13.2-3.36,4-5.42,3-8.06-9.72-8.43-11.43.43-4,1-4.47S267.78,233.33,267.78,233.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267,232.47l-.16,3.68a2.06,2.06,0,0,0,1,1.91,4,4,0,0,0,2.74.43c2.68-.43,2.91-1.19,3.1-4.87S267,232.47,267,232.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.34,165c1-17.09,18.51,2.52,18.51,2.52l12,11.71L276.56,191a10.59,10.59,0,0,1,2.67,8.52l-4.35,33.14a3.26,3.26,0,0,1-3.27,2.83,10,10,0,0,1-1.61-.14,4.06,4.06,0,0,1-3.6-4.3l.8-31-22.6-13.62S234.29,182.06,235.34,165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M222.35,171.48c1.05-17.09,18.51,2.52,18.51,2.52l11.95,11.71,10.76,11.82a10.6,10.6,0,0,1,2.67,8.52l-4.35,33.14a3.26,3.26,0,0,1-3.27,2.83,10,10,0,0,1-1.61-.14,4,4,0,0,1-3.6-4.29l.8-31L231.61,193S221.3,188.57,222.35,171.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M232.68,116.62c-13.23,5.49-13,13.32-13,13.32s2.59,28.68,1.71,47.83c-.37,8,42.54,8.62,36.14-12.74-7.54-25.19-4.71-45.58-8.25-48.66S236.1,115.2,232.68,116.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M228.42,123.56c.7,2.69,4.22,4.11,7.87,3.16s6.05-3.88,5.35-6.56-4.21-4.11-7.86-3.17S227.73,120.87,228.42,123.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M227.81,123.72h0a5.06,5.06,0,0,1,1.17-4.5,8.88,8.88,0,0,1,4.64-2.84c4-1,7.86.6,8.64,3.62a5.07,5.07,0,0,1-1.18,4.5,8.81,8.81,0,0,1-4.63,2.84,9.64,9.64,0,0,1-2.4.31C231,127.65,228.43,126.13,227.81,123.72Zm6.13-6.11a7.57,7.57,0,0,0-4,2.41,3.81,3.81,0,0,0-.92,3.38h0c.6,2.35,3.79,3.56,7.09,2.71a7.51,7.51,0,0,0,4-2.41,3.8,3.8,0,0,0,.93-3.39c-.47-1.83-2.53-3-5-3A8.22,8.22,0,0,0,233.94,117.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M238,116a31.29,31.29,0,0,0,.11,4.72c.07,1.32-4.54,2.55-5.74,1.36s-.71-2.44-1-6.92S238,116,238,116Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M231.36,115.19s1.14,4.16,6.74,5.75l-.08-3.78Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 237.67,
    cy: 107.17,
    r: 10.19,
    transform: "translate(-21.67 133.9) rotate(-30.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M235.34,107.54s5.6,2.4,9.49,2.43,3-3.22,3-3.22l-11.53-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M246,108.17s-4.89-2.07-9.18-1.21a4.59,4.59,0,0,0-2.59,1.54,1.54,1.54,0,0,1-.78.57c-.76.17-2-3-3.48-3s-2.47,1-1.26,2.91.81,4.11.25,4.42-6.47-4.21-1.26-14.55,18.47-4.76,20.53-2.67c0,0,2.17,1.89,3.93.21C252.15,96.34,254.13,111.16,246,108.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M227.14,150.89v7.75a3.16,3.16,0,0,0,1,2.34l15.92,14.51-1.81,2.77-21-15.25a4.29,4.29,0,0,1-1.74-3l-1.42-13.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M220.83,126.06s-4.83,7.26-6.63,26.39c0,0,8.25,2.66,12.94,1.15S220.83,126.06,220.83,126.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228,135.24s1.89,10.13,2,14.88a3,3,0,0,1-2,2.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M232.15,185.57l3.52-.47L258.38,172a3.14,3.14,0,0,1,2.84.12l16.1,9.29,2.13-.28v2.11h0a.85.85,0,0,1-.49.75l-25.75,14.86a3.17,3.17,0,0,1-2.84-.11l-17.53-10.12a1.14,1.14,0,0,1-.69-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M249.22,177.28l1.61-.93h17.74l8.75,5.05,2.13-.28v2.11h0a.85.85,0,0,1-.49.75l-25.75,14.86a2.63,2.63,0,0,1-1.46.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M278.5,181.24l.95-.12v2.11h0a.85.85,0,0,1-.49.75l-.46.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M253,199a3.24,3.24,0,0,1-2.42-.15v-3.6H253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M253.21,196.73,279,181.86c.73-.42.64-1.15-.21-1.64l-17.53-10.11a3.14,3.14,0,0,0-2.84-.12l-25.74,14.86c-.73.42-.64,1.16.2,1.64l17.53,10.12A3.18,3.18,0,0,0,253.21,196.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.65,194.47l21.41-12.35c.6-.35.53-1-.17-1.37l-9.4-5.28a2.63,2.63,0,0,0-2.36-.1l-21.41,12.36c-.6.35-.53,1,.17,1.36l9.4,5.29A2.63,2.63,0,0,0,253.65,194.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M260.23,169.62l.27,1.77a13.43,13.43,0,0,1-.12,4.56l-.32,1.56a2.18,2.18,0,0,1-1.76,1.73h0a1.22,1.22,0,0,1-1.43-1.06l-.42-3.79s-1,1.27-1.44,1.27.52-3.8,1.59-6S260.23,169.62,260.23,169.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M251.5,141.39l2.77,5.46A11,11,0,0,1,255.4,151l1.2,18.7,3.63-.08,1.65-21a7.42,7.42,0,0,0-.1-1.94L259.9,136Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.09,198.15l2.15-2.81,22.7-13.15a3.16,3.16,0,0,0,1.32-2.52l0-18.58,1.31-1.71-1.23-.71h0a.81.81,0,0,0-.89,0L253.7,173.62a3.15,3.15,0,0,0-1.31,2.52l0,20.24a1.15,1.15,0,0,0,.48,1.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.78,187.5l1.62-.94,8.85-15.37v-10.1l1.31-1.71-1.23-.71h0a.81.81,0,0,0-.89,0L253.7,173.62a2.67,2.67,0,0,0-1,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M281,160.14l.58-.76-1.23-.71h0a.81.81,0,0,0-.89,0L279,159Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M253.47,173.79a3.29,3.29,0,0,0-1.08,2.16l2.52,1.45,1.2-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M254.93,174.33l25.72-14.89c.73-.43,1.32,0,1.32,1l0,20.24a3.12,3.12,0,0,1-1.31,2.52L255,198.09c-.72.42-1.32,0-1.32-1l0-20.24A3.16,3.16,0,0,1,254.93,174.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M242.28,178.26l.41.85a5.77,5.77,0,0,0,2.15,2.39l2.56,1.57a2.53,2.53,0,0,0,2.6.06l.09,0a1.54,1.54,0,0,0,.22-2.36L247.64,178s1.5,1.15,1.92.69-1.46-2-2.81-2a5.39,5.39,0,0,1-2.66-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M249.05,116.33s9.79,10.65,13.74,20.42a20,20,0,0,1-11.54,8.4C243.05,147.52,249.05,116.33,249.05,116.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.09,144.52l-1.59-15.33,3.74,14.36A21.39,21.39,0,0,1,253.09,144.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M241.72,114.18l2.63-.72a6.41,6.41,0,0,1-3.09,2.48c-1.83.5-2.12-1-2.12-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M227.67,110a1.47,1.47,0,1,0,1.46-1.46A1.46,1.46,0,0,0,227.67,110Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M0,111.16l4.41-9,9,4.42-4.42,9Zm5.32-6.3-2.64,5.39,5.38,2.64,2.65-5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.26,307c9.8,5.66,25.69,5.66,35.49,0s9.8-14.83,0-20.49-25.69-5.66-35.49,0S188.46,301.38,198.26,307Zm9.59-15c4.5-2.6,11.81-2.6,16.31,0s4.51,6.81,0,9.42-11.81,2.6-16.31,0S203.34,294.69,207.85,292.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M237.45,283.2l-8.95.14a9.51,9.51,0,0,0-2.83-2.38c-4.92-2.84-12.66-3.06-18-.66l-5.32-5-8.19.12c.4-.26.82-.52,1.26-.77,11.38-6.58,29.83-6.58,41.21,0a21.57,21.57,0,0,1,5.12,4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "194.14 262.43 194.14 275.42 202.33 275.3 202.33 262.3 194.14 262.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "207.65 267.3 207.65 280.3 202.33 275.3 202.33 262.3 207.65 267.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M228.5,270.34v13l-11.78-9.6-9.07,6.56v-13l8.35-4.05s11.51,3.52,12.11,3.67S228.5,270.34,228.5,270.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "237.45 270.2 237.45 283.2 228.5 283.34 228.5 270.34 237.45 270.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "241.74 265.64 241.74 278.63 237.45 283.2 237.45 270.2 241.74 265.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M237.45,270.2l-8.95.14a9.51,9.51,0,0,0-2.83-2.38c-4.92-2.84-12.66-3.06-18-.66l-5.32-5-8.19.13q.6-.4,1.26-.78c11.38-6.58,29.83-6.58,41.21,0a21.07,21.07,0,0,1,5.12,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M205,268.9v12L197.2,279s.46-7,.62-7.18S205,268.9,205,268.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.81,280.85v13l-.83.89-5.47-3.15s.85-9.92,1-10.12A51.68,51.68,0,0,1,210.81,280.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200.27,277.49,205,281.9c-3.9,3.09-3.44,7.44,1.39,10.22a16.63,16.63,0,0,0,4.47,1.73L206,299l4.29,4a39,39,0,0,1-14.87-4.6c-9.78-5.65-11.14-14.31-4.11-20.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "210.26 290.04 210.26 303.04 199.64 298.94 186.86 286.75 186.91 272.95 200.43 283.66 210.26 290.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.27,264.49,205,268.9c-3.9,3.09-3.44,7.44,1.39,10.23a17,17,0,0,0,4.47,1.72L206,286l4.29,4a39,39,0,0,1-14.87-4.6c-9.78-5.65-11.14-14.31-4.11-20.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M210.3,298.94l4.26-4.55a20.34,20.34,0,0,0,11.11-2.27c3.14-1.81,4.43-4.28,3.88-6.63l10.16-.16,3.91-4.16c3.42,5.86,1.09,12.6-7,17.27-6,3.44-13.82,5.07-21.62,4.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "215 290.36 215 303.36 245.14 286.65 245.14 273.64 240.74 275.42 215 290.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "210.3 285.94 210.3 298.94 215 303.36 215 290.36 210.3 285.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M210.3,285.94l4.26-4.55a20.42,20.42,0,0,0,11.11-2.26c3.14-1.81,4.43-4.29,3.88-6.64l10.16-.16,3.91-4.16c3.42,5.86,1.09,12.6-7,17.27-6,3.44-13.82,5.07-21.62,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M271.39,69.8a6.5,6.5,0,1,1,6.5,6.5A6.51,6.51,0,0,1,271.39,69.8Zm2,0a4.5,4.5,0,1,0,4.5-4.5A4.51,4.51,0,0,0,273.39,69.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.68,279.33a4.72,4.72,0,1,0,4.72-4.72A4.72,4.72,0,0,0,293.68,279.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.47,9.35A5.63,5.63,0,1,0,58.1,3.73,5.62,5.62,0,0,0,52.47,9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M82.88,67.51l26.74-15.44A1.39,1.39,0,0,1,111,52v0l2.59,1.5-1.82.67V73.58a5.15,5.15,0,0,1-2.15,4.11L84.06,92.45v2.28l-2.62-1.51h0a1.92,1.92,0,0,1-.72-1.72V71.62A5.16,5.16,0,0,1,82.88,67.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M85.52,94.65l26.74-15.44a5.13,5.13,0,0,0,2.15-4.11V55.22c0-1.58-1-2.31-2.15-1.62L85.52,69a5.16,5.16,0,0,0-2.15,4.11V93C83.37,94.61,84.33,95.34,85.52,94.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M103.27,72.36c0,1.15.8,1.62,1.8,1a4,4,0,0,0,1.8-3.12c0-1.15-.8-1.62-1.8-1A4,4,0,0,0,103.27,72.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M97.8,75.52c0,1.15.81,1.61,1.8,1a4,4,0,0,0,1.81-3.13c0-1.15-.81-1.61-1.81-1A4,4,0,0,0,97.8,75.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M92.33,78.67c0,1.15.81,1.62,1.81,1a4,4,0,0,0,1.8-3.13c0-1.15-.81-1.62-1.8-1A4,4,0,0,0,92.33,78.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M212.89,37.14,239.12,22a1.33,1.33,0,0,1,1.36-.11v0L243,23.34l-1.79.65V43.1a5,5,0,0,1-2.11,4L214.05,61.6v2.25l-2.57-1.49h0a1.88,1.88,0,0,1-.71-1.68V41.17A5,5,0,0,1,212.89,37.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.48,63.77l26.23-15.15a5,5,0,0,0,2.11-4V25.08c0-1.55-.94-2.26-2.11-1.59L215.48,38.63a5.09,5.09,0,0,0-2.11,4v19.5C213.37,63.73,214.32,64.44,215.48,63.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M232.89,41.9c0,1.13.79,1.59,1.77,1a3.89,3.89,0,0,0,1.77-3.06c0-1.13-.79-1.59-1.77-1A3.89,3.89,0,0,0,232.89,41.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M227.53,45c0,1.12.79,1.58,1.77,1A3.92,3.92,0,0,0,231.07,43c0-1.13-.79-1.58-1.77-1A3.9,3.9,0,0,0,227.53,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M222.17,48.09c0,1.13.79,1.59,1.77,1a3.91,3.91,0,0,0,1.77-3.06c0-1.13-.8-1.59-1.77-1A3.89,3.89,0,0,0,222.17,48.09Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide1Bg);
export default __webpack_public_path__ + "static/media/slide1-bg.11f69b4f9c73879ae0a7a8819181e4b6.svg";
export { ForwardRef as ReactComponent };